var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgMusicOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 48,
  width: 48
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M40.2 45.3 2.75 7.85 5 5.6l37.45 37.45ZM27.5 23.65l-3.4-3.4V5.65h12.3v7.15h-8.9Zm-7.7 18.7q-3.25 0-5.475-2.25-2.225-2.25-2.225-5.45 0-3.25 2.225-5.475Q16.55 26.95 19.8 26.95q1.35 0 2.425.35 1.075.35 1.875 1v-3.6l3.4 3.4v6.55q0 3.2-2.225 5.45T19.8 42.35Z"
})));

export default SvgMusicOff;